import { Console } from "@utils/console";
import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import type React from "react";
import { useCallback } from "react";
import { InView } from "react-intersection-observer";

interface Props {
	id?: string;
	sendEvent?: boolean;
}

export const EventImpression: React.FC<Props> = ({ id, sendEvent, children }) => {
	const handleChange = useCallback(
		(isVisible) => {
			if (isVisible) {
				if (id) {
					GoogleAnalytics4.sendEvent("BM_blockImpression", {
						blockName: id,
					});
				} else {
					Console.warn("EventImpression: It wants to send event but the container doesn't have id.");
				}
			}
		},
		[id],
	);

	if (sendEvent) {
		return (
			<InView {...GoogleAnalytics4.getInViewProps()} onChange={handleChange} triggerOnce>
				{children}
			</InView>
		);
	}

	return <>{children}</>;
};
